import { Component } from 'react';
import { List } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITable from 'UIComponents/table/UITable';
import RecurringDateList from 'automation-ui-canvas/components/settings/RecurringDateList';
import { compare, now } from 'foundations-components/transitional/utils/SimpleDate';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class HolidayManagement extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      pastBlockedDatesWithIndex: null,
      currentBlockedDatesWithIndex: null,
      addDateToggle: false
    };
    this.handleAddDate = () => {
      const {
        stagedTimeWindowMetadata,
        onUpdateStagedTimeWindowMetadata
      } = this.props;
      const updatedStagedTimeWindowMetadata = stagedTimeWindowMetadata.addBlockedDate();
      onUpdateStagedTimeWindowMetadata(updatedStagedTimeWindowMetadata);
    };
    this.handleSetDate = (index, blockedDate) => {
      const {
        stagedTimeWindowMetadata,
        onUpdateStagedTimeWindowMetadata
      } = this.props;
      const updatedStagedTimeWindowMetadata = stagedTimeWindowMetadata.setBlockedDate(index, blockedDate);
      onUpdateStagedTimeWindowMetadata(updatedStagedTimeWindowMetadata);
    };
    this.handleRemoveDate = index => {
      const {
        stagedTimeWindowMetadata,
        onUpdateStagedTimeWindowMetadata
      } = this.props;
      const updatedStagedTimeWindowMetadata = stagedTimeWindowMetadata.removeBlockedDate(index);
      onUpdateStagedTimeWindowMetadata(updatedStagedTimeWindowMetadata);
    };
    this.clearBlockedDates = () => {
      const {
        stagedTimeWindowMetadata,
        onUpdateStagedTimeWindowMetadata
      } = this.props;
      const updatedStagedTimeWindowMetadata = stagedTimeWindowMetadata.set('blockedDates', List());
      onUpdateStagedTimeWindowMetadata(updatedStagedTimeWindowMetadata);
    };
    this.handleAddDateToggle = checked => {
      if (checked) {
        this.handleAddDate();
      } else {
        this.clearBlockedDates();
      }
      this.setState({
        addDateToggle: checked
      });
    };
    this.renderAddDateButton = readOnly => {
      return /*#__PURE__*/_jsxs(Button, {
        "data-test-id": "platform-holiday-settings-add-dates",
        disabled: readOnly,
        use: "link",
        onClick: this.handleAddDate,
        children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformSettings.holidayManagement.addDayLabel"
        })]
      });
    };
    this.renderAddDateToggle = readOnly => {
      return /*#__PURE__*/_jsx(Toggle, {
        "data-test-id": "platform-holiday-settings-add-dates-toggle",
        disabled: readOnly,
        checked: this.state.addDateToggle,
        onChange: ({
          target: {
            checked
          }
        }) => {
          this.handleAddDateToggle(checked);
        },
        marginBlockEnd: "200"
      });
    };
    this.renderPastDates = () => {
      const {
        pastBlockedDatesWithIndex
      } = this.state;
      if (pastBlockedDatesWithIndex && pastBlockedDatesWithIndex.size) {
        return /*#__PURE__*/_jsx(AccordionItem, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'platformSettings.holidayManagement.pastDates'
          }),
          marginBlockStart: "100",
          children: /*#__PURE__*/_jsx(UITable, {
            bordered: false,
            condensed: true,
            flush: true,
            style: {
              width: '50%'
            },
            children: /*#__PURE__*/_jsx("tbody", {
              children: pastBlockedDatesWithIndex.map(({
                index,
                blockedDate
              }) => /*#__PURE__*/_jsx("tr", {
                children: /*#__PURE__*/_jsx("td", {
                  children: blockedDate.getDisplayDate()
                })
              }, index))
            })
          })
        });
      } else {
        return null;
      }
    };
  }
  static getDerivedStateFromProps(props) {
    const {
      stagedTimeWindowMetadata
    } = props;
    const blockedDates = stagedTimeWindowMetadata.getBlockedDates();
    const hasBlockedDates = blockedDates.size > 0;
    const pastBlockedDatesWithIndex = [];
    const currentBlockedDatesWithIndex = [];
    const today = now();
    blockedDates.forEach((blockedDate, index) => {
      // date < today
      if (blockedDate.getDate() && compare(blockedDate.getDate(), today) === -1) {
        pastBlockedDatesWithIndex.push({
          index,
          blockedDate
        });
      } else {
        currentBlockedDatesWithIndex.push({
          index,
          blockedDate
        });
      }
    });
    return {
      pastBlockedDatesWithIndex: List(pastBlockedDatesWithIndex),
      currentBlockedDatesWithIndex: List(currentBlockedDatesWithIndex),
      addDateToggle: hasBlockedDates
    };
  }
  render() {
    const {
      readOnly,
      use
    } = this.props;
    const {
      currentBlockedDatesWithIndex
    } = this.state;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [this.renderAddDateToggle(!!readOnly), /*#__PURE__*/_jsx(RecurringDateList, {
        blockedDatesWithIndex: currentBlockedDatesWithIndex,
        onRemoveDate: this.handleRemoveDate,
        onSetDate: this.handleSetDate,
        readOnly: readOnly,
        use: use
      }), this.state.addDateToggle && this.renderAddDateButton(!!readOnly), this.renderPastDates()]
    });
  }
}
export default HolidayManagement;